import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Injecte le JWT sur chaque requête
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirige vers /login si 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ───────────────────────────────────────────────────────────────────
export const login = (username, password) =>
  api.post('/auth/login', { username, password }).then(r => r.data);

export const changePassword = (currentPassword, newPassword) =>
  api.post('/auth/change-password', { currentPassword, newPassword }).then(r => r.data);

// ─── Dashboard ──────────────────────────────────────────────────────────────
export const getDashboard = () =>
  api.get('/dashboard').then(r => r.data);

export const getHistory = (licenseId, days = 30) =>
  api.get(`/dashboard/history/${licenseId}?days=${days}`).then(r => r.data);

// ─── Licences ────────────────────────────────────────────────────────────────
export const getLicenses = () =>
  api.get('/licenses').then(r => r.data);

export const getLicense = id =>
  api.get(`/licenses/${id}`).then(r => r.data);

export const createLicense = data =>
  api.post('/licenses', data).then(r => r.data);

export const activateLicense = id =>
  api.put(`/licenses/${id}/activate`).then(r => r.data);

export const deactivateLicense = id =>
  api.put(`/licenses/${id}/deactivate`).then(r => r.data);

// ─── Instances ───────────────────────────────────────────────────────────────
export const getInstances = () =>
  api.get('/instances').then(r => r.data);

export const getInstancesByLicense = licenseId =>
  api.get(`/instances/by-license/${licenseId}`).then(r => r.data);

export const disableInstance = (id, reason) =>
  api.put(`/instances/${id}/disable`, { reason }).then(r => r.data);

export const enableInstance = id =>
  api.put(`/instances/${id}/enable`).then(r => r.data);

export const setInstanceEnvironment = (id, environment) =>
  api.put(`/instances/${id}/environment`, null, { params: { environment } }).then(r => r.data);

// ─── Tentatives de connexion refusées ────────────────────────────────────────
export const getConnectionAttempts = (all = false) =>
  api.get('/connection-attempts', { params: { all } }).then(r => r.data);

export const declareAttempt = (id, licenseData) =>
  api.post(`/connection-attempts/${id}/declare`, licenseData).then(r => r.data);

export const ignoreAttempt = id =>
  api.post(`/connection-attempts/${id}/ignore`).then(r => r.data);

// ─── Update Packages ─────────────────────────────────────────────────────────
export const getPackages = () =>
  api.get('/packages').then(r => r.data);

export const getPackagesForLicense = licenseId =>
  api.get(`/packages/license/${licenseId}`).then(r => r.data);

export const uploadPackage = formData =>
  api.post('/packages', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);

export const downloadPackage = id =>
  api.get(`/packages/${id}/download`, { responseType: 'blob' }).then(r => r.data);

export const deletePackage = id =>
  api.delete(`/packages/${id}`).then(r => r.data);

// ─── Instance Updates ────────────────────────────────────────────────────────
export const requestUpdate = (instanceId, packageId, notes) =>
  api.post(`/instances/${instanceId}/request-update`, { packageId, notes }).then(r => r.data);

export const getInstanceUpdateHistory = instanceId =>
  api.get(`/instances/${instanceId}/updates`).then(r => r.data);

export const getLicenseUpdateHistory = licenseId =>
  api.get(`/licenses/${licenseId}/updates`).then(r => r.data);
